// src/components/RoleSwitcher.jsx

import React, { useState } from "react";
import { useUser } from "../context/UserContext";
import { FiChevronDown, FiShield, FiUser, FiUsers } from 'react-icons/fi';

const roles = [
  { value: "admin", label: "Admin", icon: FiShield, color: "text-red-600", bgColor: "bg-red-50" },
  { value: "clinician", label: "Clinician", icon: FiUser, color: "text-blue-600", bgColor: "bg-blue-50" },
  { value: "receptionist", label: "Receptionist", icon: FiUsers, color: "text-green-600", bgColor: "bg-green-50" },
];

export default function RoleSwitcher() {
  const { user, switchRole } = useUser();
  const [isOpen, setIsOpen] = useState(false);
  
  const currentRole = roles.find(r => r.value === user.role) || roles[1];
  const CurrentIcon = currentRole.icon;

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 px-3 py-2 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
      >
        <div className={`p-1 rounded ${currentRole.bgColor}`}>
          <CurrentIcon className={`h-4 w-4 ${currentRole.color}`} />
        </div>
        <span className="text-sm font-medium text-gray-700">{currentRole.label}</span>
        <FiChevronDown className={`h-4 w-4 text-gray-400 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>
      
      {isOpen && (
        <div className="absolute right-0 top-full mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg py-1 z-50">
          <div className="px-3 py-2 border-b border-gray-200">
            <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">Switch Role</p>
            <p className="text-xs text-gray-400 mt-1">For testing purposes</p>
          </div>
          {roles.map(role => {
            const Icon = role.icon;
            const isSelected = role.value === user.role;
            
            return (
              <button
                key={role.value}
                onClick={() => {
                  switchRole(role.value);
                  setIsOpen(false);
                }}
                className={`w-full flex items-center space-x-3 px-3 py-2 text-left hover:bg-gray-50 transition-colors ${
                  isSelected ? 'bg-blue-50 border-r-2 border-blue-500' : ''
                }`}
              >
                <div className={`p-1 rounded ${role.bgColor}`}>
                  <Icon className={`h-4 w-4 ${role.color}`} />
                </div>
                <span className={`text-sm font-medium ${
                  isSelected ? 'text-blue-700' : 'text-gray-700'
                }`}>
                  {role.label}
                </span>
                {isSelected && (
                  <div className="ml-auto w-2 h-2 bg-blue-500 rounded-full" />
                )}
              </button>
            );
          })}
        </div>
      )}
      
      {/* Overlay to close dropdown when clicking outside */}
      {isOpen && (
        <div 
          className="fixed inset-0 z-40" 
          onClick={() => setIsOpen(false)}
        />
      )}
    </div>
  );
}
